// src/app/version.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilityService } from '../../utility/utility.service';
import { environmentProd } from 'src/environments/environment.prod';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  getProdOrDevUrl: boolean | undefined;
  requestOptions: {} | undefined;
  headers: {} | undefined;
  private GET_VERSION_URL: string = '';
  private GET_UI_VERSION: string = '';

  constructor(
    private httpClient: HttpClient,
    private utility: UtilityService,
  ) {

    const isProd = this.utility.getProdOrDevUrl();
    let urlTobe = isProd ? environmentProd.api_base_url : environment.api_base_url;

    this.GET_VERSION_URL = urlTobe + 'pre-login/getRoleWiseDeployedVersion/v1/';
    this.GET_UI_VERSION = urlTobe + 'pre-login/getFeatureList/v1/';

  }

  getAppVersion(data:any): Observable<string> {
    const apiVersion = this.utility.getApiVersion(this.GET_VERSION_URL);
    this.requestOptions = this.utility.getHeader(data, apiVersion);
    return this.httpClient.get<any>(
      this.GET_VERSION_URL + data,
      this.requestOptions,
    );
  }

  getUiVersion(data:any): Observable<string> {
    const apiVersion = this.utility.getApiVersion(this.GET_UI_VERSION);
    this.requestOptions = this.utility.getHeader(data, apiVersion);
    return this.httpClient.get<any>(
      this.GET_UI_VERSION + encodeURIComponent(data),
      this.requestOptions,
    );
  }
}
